import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, CardActions, CardContent, Grid, Paper, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';
import { useAppContext } from '@/context';

const PasswordResetSuccess = ({ ...props }) => {
  const { stepToRender, setCurrentStep } = props;

  const navigate = useNavigate();
  const { pathname = '' } = useLocation();
  const { queryParams, setQueryParams } = useAppContext();

  return (
    <Grid
      id="password-reset-success-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        size={{ xs: 12, sm: 12, md: 6 }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        sx={{ minHeight: '100vh' }}
      >
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px' } }}>
            <CardContent>
              <Typography variant="h1" mb={2}>
                New password saved.
              </Typography>
              <Box mb={2}>
                <Typography variant="subtitle1">Use your new password next time you log in.</Typography>
              </Box>
            </CardContent>
            <CardActions sx={{ justifyContent: 'space-between' }}>
              <Button
                color="primary"
                onClick={() => {
                  // clear out the authIndexValue
                  setQueryParams({
                    ...queryParams,
                    authIndexValue: undefined,
                  });

                  if (pathname.indexOf('login') >= 0) {
                    // re-set the current step with the existing step to trigger login navigation
                    // should work since the default confirmation callback option is 0 -> which points to login.
                    setCurrentStep(stepToRender);
                  } else {
                    // else if from forgotten password journey, navigate to login route
                    navigate('/login');
                  }
                }}
                sx={{ width: '100%' }}
              >
                Continue
              </Button>
            </CardActions>
          </Paper>
        </Grid>
        <Footer />
      </Grid>
    </Grid>
  );
};

PasswordResetSuccess.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default PasswordResetSuccess;
